<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="4">
              <v-select
                v-model="remesa.fk_idLoc"
                :items="locOptions"
                item-value="idLoc"
                item-text="displayText"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
              >
                <template v-slot:label>ID loc</template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaAlta"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaAltaFormatted"
                    label="Fecha alta"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="fechaAltaString"
                  @input="menuFechaAlta = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaTramite"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaTramiteFormatted"
                    label="Fecha de trámite"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="fechaTramiteString"
                  @input="menuFechaTramite = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="remesa.numOficio"
                label="Número de oficio"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :loading="loading" @click="guardarCambios"> Guardar cambios </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    TextButton,
  },

  props: {
    remesaSeleccionada: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      menuFechaAlta: false,
      menuFechaTramite: false,
      remesa: {
        fk_idLoc: 0,
        fechaAlta: '',
        fechaTramite: '',
        numOficio: '',
      },
    }
  },

  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),
    locOptions() {
      return this.locs.map((loc) => ({
        idLoc: loc.idLoc,
        displayText: `${loc.noLicencia}`,
      }))
    },
    fechaAltaFormatted: {
      get() {
        return this.remesa.fechaAlta ? moment(this.remesa.fechaAlta).format('DD/MM/YYYY') : ''
      },
      set(value) {
        const date = moment(value, 'DD/MM/YYYY', true)
        this.remesa.fechaAlta = date.isValid() ? date.toDate() : null
      },
    },
    fechaTramiteFormatted: {
      get() {
        return this.remesa.fechaTramite ? moment(this.remesa.fechaTramite).format('DD/MM/YYYY') : ''
      },
      set(value) {
        const date = moment(value, 'DD/MM/YYYY', true)
        this.remesa.fechaTramite = date.isValid() ? date.toDate() : null
      },
    },
    fechaAltaString: {
      get() {
        return this.remesa.fechaAlta ? moment(this.remesa.fechaAlta).format('YYYY-MM-DD') : ''
      },
      set(value) {
        this.remesa.fechaAlta = value ? moment(value, 'YYYY-MM-DD').toDate() : null
      },
    },
    fechaTramiteString: {
      get() {
        return this.remesa.fechaTramite ? moment(this.remesa.fechaTramite).format('YYYY-MM-DD') : ''
      },
      set(value) {
        this.remesa.fechaTramite = value ? moment(value, 'YYYY-MM-DD').toDate() : null
      },
    },
  },

  methods: {
    ...mapActions('remesas', ['updateRemesa']),
    async guardarCambios() {
      this.loading = true
      try {
        const payload = {
          fk_idLoc: this.remesa.fk_idLoc,
          fechaAlta: this.remesa.fechaAlta ? moment(this.remesa.fechaAlta).format('YYYY-MM-DD') : '',
          fechaTramite: this.remesa.fechaTramite ? moment(this.remesa.fechaTramite).format('YYYY-MM-DD') : '',
          numOficio: this.remesa.numOficio,
        }
        await this.updateRemesa({ payload, idRemesa: this.remesaSeleccionada.idRemesa })
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    if (this.remesaSeleccionada) {
      this.remesa = {
        ...this.remesaSeleccionada,
        fechaAlta: this.remesaSeleccionada.fechaAlta
          ? moment(this.remesaSeleccionada.fechaAlta, 'YYYY-MM-DD').toDate()
          : null,
        fechaTramite: this.remesaSeleccionada.fechaTramite
          ? moment(this.remesaSeleccionada.fechaTramite, 'YYYY-MM-DD').toDate()
          : null,
      }
    }
  },
}
</script>
